<p-card [header]="'auth.loading.title' | translate" [style]="{ width: '500px' }">
  <p>{{ 'auth.loading.message' | translate }}</p>
  <app-loading />
</p-card>
